// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { formActions, mergeActionsToProps } from 'redux-pure-form';

import type { MapStateToProps } from 'react-redux';

import Select, { getOption } from '../../form/select.js';
import EventContainer from './calendar.event-container.js';

import { EVENT_CANCEL, cancelReasonOptions, cancelActionOptions } from '../calendar.consts.js';

import { cancelEvent } from '../calendar-day.actions.js';

type OwnProps = {||};

type MappedState = {|
  UI: UI,
  URL: URL
|};

type Props = {|
  ...OwnProps,
  ...MappedState
|};

class EventCancel extends React.Component<Props> {
  static footer = true;

  constructor(props: Props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit: Function;
  handleSubmit(e) {
    e.preventDefault();
    this.props.cancelEvent();
  }

  render() {
    const { event, fieldAttrs } = this.props;

    return (
      <EventContainer>
        <form onSubmit={this.handleSubmit}>
          <p className="text-danger">
            Every organization has own cancelation rules. Please read it before cancel event.
          </p>

          <Select
            id="reason"
            className="form-control"
            title="Select Reason"
            placeholder="Select Reason"
            label="Reason"
            options={cancelReasonOptions}
            value={event.reason}
            name="event.reason"
            required
            {...fieldAttrs}
          />

          {event.recurring === '1' ? (
            <Select
              id="eventsForAction"
              className="form-control"
              title="Select Action"
              placeholder="Select Action"
              label="Action"
              options={cancelActionOptions}
              value={event.eventsForAction}
              name="event.eventsForAction"
              required
              {...fieldAttrs}
            />
          ) : null}

          {event.reason === 'other' ? (
            <textarea
              className="form-control"
              title="Other reason"
              placeholder="Enter at least 10 characters for your cancellation reason"
              value={event.textReason}
              name="event.textReason"
              rows="4"
              minLength="10"
              maxLength="1000"
              required
              {...fieldAttrs}
            />
          ) : null}

          <input id={EVENT_CANCEL} type="submit" style={{ display: 'none' }} />
        </form>
      </EventContainer>
    );
  }
}

const mapStateToProps: MapStateToProps<ReduxState, OwnProps, MappedState> = state => ({
  event: state.event
});

export default connect(
  mapStateToProps,
  {
    cancelEvent,
    ...formActions
  },
  mergeActionsToProps
)(EventCancel);
